export interface ValidationMessages {
  valueMissing:    string;
  typeMismatch:    string;
  patternMismatch: string;
  tooShort:        string;
  tooLong:         string;
  rangeUnderflow:  string;
  rangeOverflow:   string;
  stepMismatch:    string;
}

export const defaultMessages: Readonly<ValidationMessages> = {
  valueMissing:    'This field is required.',
  typeMismatch:    'Please enter a valid value.',
  patternMismatch: 'Please match the requested format.',
  tooShort:        'This value is too short.',
  tooLong:         'This value is too long.',
  rangeUnderflow:  'This value is too low.',
  rangeOverflow:   'This value is too high.',
  stepMismatch:    'Please enter a valid value.',
};

export function resolveMessage(
  flags:     ValidityStateFlags,
  overrides?: Partial<ValidationMessages>,
): string {
  const msgs = overrides ? { ...defaultMessages, ...overrides } : defaultMessages;
  if (flags.valueMissing)    return msgs.valueMissing;
  if (flags.typeMismatch)    return msgs.typeMismatch;
  if (flags.patternMismatch) return msgs.patternMismatch;
  if (flags.tooShort)        return msgs.tooShort;
  if (flags.tooLong)         return msgs.tooLong;
  if (flags.rangeUnderflow)  return msgs.rangeUnderflow;
  if (flags.rangeOverflow)   return msgs.rangeOverflow;
  if (flags.stepMismatch)    return msgs.stepMismatch;
  return '';
}
